interface Location {
    company_id: string;
    lat: string;
    lng: string;
}

export const locations: Location[] = [
    {
        company_id: "70000001046420165",
        lat: "56.021634",
        lng: "37.472506",
    },
    {
        company_id: "70000001044158708",
        lat: "56.008005",
        lng: "37.477871",
    },
    {
        company_id: "70000001044161259",
        lat: "55.954228",
        lng: "37.485184",
    },
    {
        company_id: "70000001044161285",
        lat: "55.945279",
        lng: "37.532532",
    },
    {
        company_id: "70000001044159170",
        lat: "55.929792",
        lng: "37.43575",
    },
    {
        company_id: "70000001044159129",
        lat: "55.896772",
        lng: "37.463967",
},
    {
        company_id: "70000001046419583",
        lat: "55.914891",
        lng: "37.502429",
    },
    {
        company_id: "70000001044161243",
        lat: "55.907921",
        lng: "37.502331",
    },
    {
        company_id: "70000001046419497",
        lat: "55.909085",
        lng: "37.583851",
    },
    {
        company_id: "70000001044159115",
        lat: "55.896006",
        lng: "37.40566",
    },
    {
        company_id: "70000001044159189",
        lat: "55.945727",
        lng: "37.278185",
    },
    {
        company_id: "70000001046420085",
        lat: "55.933197",
        lng: "37.192851",
    },
    {
        company_id: "70000001044158662",
        lat: "55.846141",
        lng: "37.242919",
    },
    {
        company_id: "70000001046418916",
        lat: "55.723683",
        lng: "37.55796",
    },
    {
        company_id: "70000001044161816",
        lat: "56.002154",
        lng: "37.801499",
    },
    {
        company_id: "70000001046419805",
        lat: "55.977068",
        lng: "37.138070",
    },
    {
        company_id: "70000001044158796",
        lat: "55.949684",
        lng: "37.784219",
    },
    {
        company_id: "70000001046419518",
        lat: "55.835906",
        lng: "37.402662",
    },
    {
        company_id: "70000001046420100",
        lat: "55.977047",
        lng: "37.138171",
    },
    {
        company_id: "70000001044158618",
        lat: "55.834697",
        lng: "37.336148",
    },
    {
        company_id: "70000001044158787",
        lat: "55.903619",
        lng: "37.791786",
    },
    {
        company_id: "70000001043420911",
        lat: "55.586325",
        lng: "37.741010",
    },
    {
        company_id: "70000001044161519",
        lat: "55.877091",
        lng: "37.126601",
    },
    {
        company_id: "70000001044158494",
        lat: "55.892108",
        lng: "37.863619",
    },
    {
        company_id: "70000001044160273",
        lat: "55.831057",
        lng: "37.947522",
    },
    {
        company_id: "70000001044161576",
        lat: "55.96037",
        lng: "37.919415",
    },
    {
        company_id: "70000001046420174",
        lat: "55.759320",
        lng: "37.836617",
    },
    {
        company_id: "70000001044160333",
        lat: "55.800399",
        lng: "37.963092",
    },
    {
        company_id: "70000001044161340",
        lat: "55.95062",
        lng: "37.955589",
    },
    {
        company_id: "70000001044161378",
        lat: "55.923273",
        lng: "37.943044",
    },
    {
        company_id: "70000001044161303",
        lat: "55.945899",
        lng: "37.958192",
    },
    {
        company_id: "70000001046419608",
        lat: "55.91728",
        lng: "37.94358",
    },
    {
        company_id: "70000001044161391",
        lat: "55.67094",
        lng: "37.249074",
    },
    {
        company_id: "70000001046418843",
        lat: "55.73852",
        lng: "37.629162",
    },
    {
        company_id: "70000001046419491",
        lat: "55.682941",
        lng: "37.779989",
    },
    {
        company_id: "70000001046419415",
        lat: "55.75799",
        lng: "37.722787",
    },
    {
        company_id: "70000001046419784",
        lat: "55.813328",
        lng: "37.070437",
    },
    {
        company_id: "70000001046419896",
        lat: "56.139791",
        lng: "37.989558",
    },
    {
        company_id: "70000001046419474",
        lat: "55.67307",
        lng: "37.818302",
    },
    {
        company_id: "70000001046419924",
        lat: "55.969001",
        lng: "38.033945",
    },
    {
        company_id: "70000001044161843",
        lat: "55.970549",
        lng: "38.03602",
    },
    {
        company_id: "70000001044160071",
        lat: "55.777162",
        lng: "37.851851",
    },
    {
        company_id: "70000001044160151",
        lat: "55.780203",
        lng: "37.860042",
    },
    {
        company_id: "70000001044160140",
        lat: "55.777561",
        lng: "37.858128",
    },
    {
        company_id: "70000001044161308",
        lat: "55.937715",
        lng: "38.039277",
    },
    {
        company_id: "70000001044160370",
        lat: "55.771959",
        lng: "37.87851",
    },
    {
        company_id: "70000001044161197",
        lat: "55.769600",
        lng: "37.884022",
    },
    {
        company_id: "70000001046419947",
        lat: "55.851753",
        lng: "38.507731",
    },
    {
        company_id: "70000001046419776",
        lat: "55.686303",
        lng: "37.197422",
    },
    {
        company_id: "70000001046419437",
        lat: "55.652959",
        lng: "37.548105",
    },
    {
        company_id: "70000001044158412",
        lat: "55.783866",
        lng: "37.980448",
    },
    {
        company_id: "70000001046440812",
        lat: "56.123495",
        lng: "38.124975",
    },
    {
        company_id: "70000001050305973",
        lat: "55.753823",
        lng: "37.951512",
    },
    {
        company_id: "70000001046419752",
        lat: "55.557685",
        lng: "38.109558",
    },
    {
        company_id: "70000001046417184",
        lat: "55.596761",
        lng: "37.532115",
    },
    {
        company_id: "70000001044158770",
        lat: "55.661562",
        lng: "37.893858",
    },
    {
        company_id: "70000001044161221",
        lat: "55.809235",
        lng: "38.150027",
    },
    {
        company_id: "70000001046420188",
        lat: "55.592537",
        lng: "37.628215",
    },
    {
        company_id: "70000001044161603",
        lat: "55.863547",
        lng: "38.201731",
    },
    {
        company_id: "70000001046419462",
        lat: "55.586217",
        lng: "37.603373",
    },
    {
        company_id: "70000001046417235",
        lat: "55.578784",
        lng: "37.590663",
    },
    {
        company_id: "70000001046419986",
        lat: "55.702794",
        lng: "36.872522",
    },
    {
        company_id: "70000001045816690",
        lat: "55.700532",
        lng: "36.870932",
    },
    {
        company_id: "70000001044161206",
        lat: "55.801539",
        lng: "38.205897",
    },
    {
        company_id: "70000001046419936",
        lat: "55.824961",
        lng: "38.258179",
    },
    {
        company_id: "70000001044158721",
        lat: "55.598820",
        lng: "37.885930",
    },
    {
        company_id: "70000001046419536",
        lat: "55.539940",
        lng: "37.391359",
    },
    {
        company_id: "70000001044161507",
        lat: "55.609339",
        lng: " 37.006898",
    },
    {
        company_id: "70000001046420076",
        lat: "55.614622",
        lng: "36.968360",
    },
    {
        company_id: "70000001046419637",
        lat: "55.623582",
        lng: "38.035694",
    },
    {
        company_id: "70000001044161882",
        lat: "55.729679",
        lng: "38.222564",
    },
    {
        company_id: "70000001044159932",
        lat: "55.385693",
        lng: "37.779479",
    },
    {
        company_id: "70000001044161398",
        lat: "55.548221",
        lng: "37.07482",
    },
    {
        company_id: "70000001044158746",
        lat: "55.560985",
        lng: "37.941244",
    },
    {
        company_id: "70000001044158803",
        lat: "55.486069",
        lng: "37.57456",
    },
    {
        company_id: "70000001046420163",
        lat: "56.123546",
        lng: "38.425908",
    },
    {
        company_id: "70000001044159686",
        lat: "55.474425",
        lng: "37.715884",
    },
    {
        company_id: "70000001044159261",
        lat: "55.467725",
        lng: "37.779251",
    },
    {
        company_id: "70000001046419966",
        lat: "55.31742",
        lng: "37.90201",
    },
    {
        company_id: "70000001044159238",
        lat: "55.437163",
        lng: "37.765857",
    },
    {
        company_id: "70000001044161692",
        lat: "55.846039",
        lng: "38.483366",
    },
    {
        company_id: "70000001044159747",
        lat: "55.441025",
        lng: "37.724386",
    },
    {
        company_id: "70000001044161871",
        lat: "55.761724",
        lng: "38.441362",
    },
    {
        company_id: "70000001044159766",
        lat: "55.436488",
        lng: "37.781635",
    },
    {
        company_id: "70000001044158868",
        lat: "55.604922",
        lng: "38.278700",
    },
    {
        company_id: "70000001044158853",
        lat: "55.555013",
        lng: "38.206760",
    },
    {
        company_id: "70000001046419766",
        lat: "55.407556",
        lng: "37.206165",
    },
    {
        company_id: "70000001044159923",
        lat: "55.417875",
        lng: "37.830102",
    },
    {
        company_id: "70000001046420043",
        lat: "55.364808",
        lng: "37.56434",
    },
    {
        company_id: "70000001044158819",
        lat: "55.360407",
        lng: "37.562203",
    },
    {
        company_id: "70000001044161704",
        lat: "55.794192",
        lng: "38.65281",
    },
    {
        company_id: "70000001044159966",
        lat: "55.329153",
        lng: "37.819524",
    },
    {
        company_id: "70000001044161465",
        lat: "55.413396",
        lng: "38.250237",
    },
    {
        company_id: "70000001044161561",
        lat: "55.889273",
        lng: "38.79883",
    },
    {
        company_id: "70000001044159995",
        lat: "55.278262",
        lng: "37.907531",
    },
    {
        company_id: "70000001044161862",
        lat: "55.170741",
        lng: "37.417209",
    },
    {
        company_id: "70000001057577555",
        lat: "55.825034",
        lng: "39.026859",
    },
    {
        company_id: "70000001044161487",
        lat: "55.581172",
        lng: "38.914237",
    },
    {
        company_id: "70000001049715674",
        lat: "55.596194",
        lng: "37.729541",
    },
    {
        company_id: "70000001044159722",
        lat: "55.477963",
        lng: "37.729644",
    }
]
